// extracted by mini-css-extract-plugin
module.exports = {"menuTabBar":"MenuTabBar_menuTabBar__7TchX","menuItem":"MenuTabBar_menuItem__1Mf1l","active":"MenuTabBar_active__sIcwh"};